/**********************************************************
Chemical Application Form
**********************************************************/
import { TextInput, NumberInput, Select, DatePicker,AutoComplete,
  RadioButton, SelectField } from '../inputs';
import FertAppliedTable from './fert_applied_table';
import { packageForm, mapEmployeeForAutoComplete,
  onDummyComplete } from '../../cult_utils';
import { UNITS_OF_MEASURE } from '../../cult_constants';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const propTypes = {
  chemicalList: PropTypes.array,
  eid: PropTypes.string,
  employees: PropTypes.array,
  fields: PropTypes.array,
  isEditing: PropTypes.bool,
  solutions: PropTypes.array,
  totalGallons: PropTypes.number
};

class FertilizerForm extends Component {
  render() {
    return (
      <div>
        <form id={this.props.formId} onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="col s12 m3 l3 xl3">
              <DatePicker id={'fert-date'} label={'Date'} min={'2019-01-01'} max={moment().format('YYYY-MM-DD')} required={true} />
            </div>
            <div className="col s12 m3 l3 xl3">
              <label>Location</label>
              <div className="radio-flex">
                <RadioButton id={'fert-kau'} name={'fert-location'} value={'71'} label={'Kau'} onClick={(e) => this.props.fetchFields(e.target.value)} />
                <RadioButton id={'fert-keaau'} name={'fert-location'} value={'72'} label={'Keaau'} onClick={(e) => this.props.fetchFields(e.target.value)} />
              </div>
            </div>
            <div className="col s12 m4 l3 xl3">
              <AutoComplete id={'fert-employee'} label={'Employee'} data={mapEmployeeForAutoComplete(this.props.employees)} onComplete={onDummyComplete} />
            </div>
            <div className="col s12 m3 l3 xl3">
              <NumberInput id={'fert-round'} label={'Round'} min={'1'} max={'10'} step={'1.0'} defaultValue={1} required={true} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m6 l6 xl6">
              <label>Type of Application</label>
              <div className="radio-flex">
                <RadioButton id={'fert-solid'} name={'fert-solidOrLiquid'} label={'Granular (Solid)'} value={'S'} onClick={(e) => this.props.setFertilizerForm({ val: e.target.value} )} checked={true} />
                <RadioButton id={'fert-liquid'} name={'fert-solidOrLiquid'} label={'Foliar Spray (Liquid)'} value={'L'} onClick={(e) => this.props.setFertilizerForm({ val: e.target.value} )} />
              </div>
            </div>
            <div className="col s12 m6 l6 xl6">
              <label>Status</label>
              <div className="radio-flex">
                <RadioButton id={'fert-isCompleteYes'} name={'fert-isComplete'} label={'Complete'} value={'Complete'} />
                <RadioButton id={'fert-isCompleteNo'} name={'fert-isComplete'} label={'Incomplete'} value={'Incomplete'} />
              </div>
            </div>
            {
              this.props.solidOrLiquid === 'S' ?
                <div className="col s12 m12 l12 xl12">
                  <TextInput id={'fert-comments'} label={'Comments'} defaultValue={'N/A'} />
                </div>
              :
              <div>
                <div className="col s12 m6 l6 xl6">
                  <NumberInput id={'fert-measurement'} label={'Total Gallons'} min={'1'} max={'10000'} step={'1.0'} />
                </div>
                <div className="col s12 m6 l6 xl6">
                  <TextInput id={'fert-comments'} label={'Comments'} defaultValue={'N/A'} />
                </div>
              </div>
            }

          </div>
        </form><hr />
        {
          this.props.solidOrLiquid === 'S' ?
          <form id={'fert-used-form-S'} onSubmit={(e) => e.preventDefault()}>
            <div className="row">
              <div className="col s12 m2 l2 xl2">
                <Select id={'fertUsed-chemId'} label={'Fertilizer'}
                  opts={this.props.chemicalList.map((c) => { return { label: c.name, val: c.id}; } )}  />
              </div>
              <div className="col s6 m2 l2 xl2">
                <SelectField id={'fertUsed-field'} label={'Field'} opts={this.props.fields} />
              </div>
              <div className="col s6 m2 l2 xl2">
                <NumberInput id={'fertUsed-hours'} label={'Hours'} min={"0"} max={"5000"} step={"0.1"} />
              </div>
              <div className="col s6 m2 l2 xl2">
                <NumberInput id={'fertUsed-acresCompleted'} label={'Acres Completed'} min={"0"} max={"5000"} step={"0.1"} />
              </div>
              <div className="col s6 m2 l2 xl2">
                <NumberInput id={'fertUsed-quantityApplied'} label={'Quantity (In Tons)'} min={"0"} max={"5000"} step={"0.1"} />
              </div>
              <input type="hidden" id={'fertUsed-unitOfMeasure'} value={'tons'} />
              <input type="hidden" id={'fertUsed-appType'} value={'S'} />
              <div className="col s12 m2 l2 xl2">
              {
                this.props.isEditing ?
                  <center>
                    <button className="btn btn-large blue chem-add"
                      onClick={() => this.props.editFertilizer({
                        fertilizer: packageForm('fert-used-form-S'),
                        fertAppId: this.props.fertAppId,
                        editFertilizerApplied: this.props.editFertilizerApplied,
                        formId: 'fert-used-form-S',
                        chemicals: this.props.chemicalList
                      })}>
                      Edit Record
                    </button>
                  </center>
                : <center>
                    <button className="btn btn-large chem-add"
                      onClick={() => this.props.addFertilizer({
                        fertilizer: packageForm('fert-used-form-S'),
                        formId: 'fert-used-form-S',
                        chemicals: this.props.chemicalList
                      })}>
                      Add Record
                    </button>
                  </center>
              }
              </div>
            </div>
          </form> :
          <div>
            <form id={'fert-used-form-L'} onSubmit={(e) => e.preventDefault()}>
              <div className="row">
                <div className="col s6 m2 l4 xl4">
                  <SelectField id={'fertUsed-field'} label={'Field'} opts={this.props.fields} />
                </div>
                <div className="col s6 m2 l4 xl4">
                  <NumberInput id={'fertUsed-hours'} label={'Hours'} min={"0"} max={"5000"} step={"0.1"} />
                </div>
                <div className="col s6 m2 l4 xl4">
                  <NumberInput id={'fertUsed-acresCompleted'} label={'Acres Completed'} min={"0"} max={"5000"} step={"0.1"} />
                </div>
              </div>
            </form><hr />
            <form id={'fert-used-form-LD'} onSubmit={(e) => e.preventDefault()}>
              <div className="row">
                <div className="col s12 m2 l3 xl3">
                  <Select id={'fertUsed-chemId'} label={'Fertilizer'}
                    opts={this.props.chemicalList.map((c) => { return { label: c.name, val: c.id}; } )}  />
                </div>
                <div className="col s12 m2 l3 xl3">
                  <NumberInput id={'fertUsed-quantityApplied'} label={'Quantity'} min={"0"} max={"5000"} step={"0.1"} />
                </div>
                <div className="col s12 m2 l3 xl3">
                  <Select id={'fertUsed-unitOfMeasure'} label={'Unit'} opts={UNITS_OF_MEASURE.filter((c) => c.type === 'volume')} />
                </div>
                <input type="hidden" id={'fertUsed-appType'} value={'L'} />
                <div className="col s12 m3 l3 xl3">
                {
                  this.props.isEditing ?
                    <center>
                      <button className="btn btn-large blue chem-add"
                        onClick={() => this.props.editFertilizer({
                          fertilizer: { ...packageForm('fert-used-form-L'), ...packageForm('fert-used-form-LD')  },
                          fertAppId: this.props.fertAppId,
                          editFertilizerApplied: this.props.editFertilizerApplied,
                          formId: 'fert-used-form-LD',
                          chemicals: this.props.chemicalList
                        })}>
                        Edit Record
                      </button>
                    </center>
                  : <center>
                      <button className="btn btn-large chem-add"
                        onClick={() => this.props.addFertilizer({
                          fertilizer: { ...packageForm('fert-used-form-L'), ...packageForm('fert-used-form-LD')  },
                          formId: 'fert-used-form-LD',
                          chemicals: this.props.chemicalList
                        })}>
                        Add Record
                      </button>
                    </center>
                }
                </div>
              </div>
            </form>
            <div className="row">

            </div>
          </div>
        }
        { this.props.fertilizerApplied.length > 0 ?
          <div className="row">
            <div className="col s12">
              <FertAppliedTable fertilizers={this.props.fertilizerApplied} chemicalList={this.props.chemicalList} formId={'chemicals-used-form'}
              _edit={this.props.selectFertilizerToEdit} _delete={this.props.deleteFertilizer} readOnly={false} editChem={false} />
            </div>
          </div>
          : ''
        }
      </div>
    );
  }
}

FertilizerForm.propTypes = propTypes;
export default FertilizerForm;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/fertilizer/fertilizer_form.js